<template>
  <div class="gallery-packs app-page-wrapper absolute" data-cy="gallery-packs">
    <gallery-menu />

    <header
      class="gallery-packs-header w-full safe-area text-28 text-texts-standard-default flex justify-between items-center"
    >
      <aside class="flex items-center">
        <app-icon class="ml-1" icon-name="info-rounded" />

        <p class="text-left ml-5">
          {{ $t('gallery.packsInfo') }}
        </p>
      </aside>

      <app-button
        class="gallery-packs-header-btn"
        btn-id="gallery-packs-header-btn"
        btn-type="credit"
        :btn-text="$t('gallery.buyMorePacks')"
        btn-size="md"
        @click="goToPremium"
      />
    </header>

    <main class="gallery-packs-main flex justify-evenly w-full">
      <gallery-pack
        v-for="(pack, index) in packs"
        :key="index"
        :pack="pack"
      />
    </main>
  </div>
</template>

<script lang="ts">
import { pathImages } from '@/globalVariables'
import { defineComponent } from 'vue'
import { mapState, mapActions } from 'pinia'
import GalleryMenu from '@/components/Gallery/GalleryMenu.vue'
import GalleryPack from '@/components/Gallery/GalleryPack.vue'
import { useGalleryPacksStore } from '@/store/pinia/gallery/packsStore'

interface ComponentData {
  pathImages: typeof pathImages
}

export default defineComponent({
  name: 'GalleryPacks',

  components: {
    GalleryMenu,
    GalleryPack,
  },

  data(): ComponentData {
    return {
      pathImages
    }
  },

  computed: {
    ...mapState(useGalleryPacksStore, ['packs']),
  },

  created(): void {
    this.loadPacks()
  },

  methods: {
    ...mapActions(useGalleryPacksStore, ['loadPacks']),

    goToPremium(): void {
      this.$router.push({ name: this.$getWebView('PremiumGalleryPieces') })
    },
  },
})
</script>

<style lang="scss" scoped>
.gallery-packs {
  @include background(url('#{$path-gallery}BG_FULLSCREEN.avif?v1'), cover);
  &-header {
    padding: 1.5rem 2.5rem;
  }
}
</style>
